import * as actionTypes from "./Actions/actions";
import undoable, { excludeAction } from "redux-undo";

let canvas = {
  title: null,
  description: null,
  meta_title: null,
  navClass: "default",
  containerBgColor: "#FFFFFF",
  surroundBg: { r: 252, g: 252, b: 252, a: 1 },
  hamburgerMenu: {
    menu: false,
    label: "",
  },
  hamburgerColor: { r: 0, g: 0, b: 0, a: 1 },
  enableWidthForRow: false,
  canvasStyle: {
    columnGap: "50",
    rowGap: "20",
    canvasPaddingUnit: "px",
    canvasPadding: [15, 0, 15, 0],
    canvasMarginUnit: "px",
    canvasMargin: [30, 30],
    canvasPaddingMobile: [0, 0, 0, 0],
    canvasMarginMobile: [0, 0],
    overrideCanvasFont: false,
    canvasRowsPaddingUnit: "px",
    canvasRowsPadding: [0, 50, 0, 50], //top right bottom left   // padding for all rows
    canvasRowsPaddingMobile: [0, 20, 0, 20], //top right bottom left   // padding for all rows
    elementsFont: {
      h1: {
        font_family: "Montserrat",
        font_size: "40",
        color: { r: 0, g: 0, b: 0, a: 1 },
        margin_bottom: "9",
        line_height: "1",
      },
      h2: {
        font_family: "Montserrat",
        font_size: "34",
        color: { r: 0, g: 0, b: 0, a: 1 },
        margin_bottom: "8",
        line_height: "1",
      },
      h3: {
        font_family: "Montserrat",
        font_size: "24",
        color: { r: 0, g: 0, b: 0, a: 1 },
        margin_bottom: "6",
        line_height: "1.1",
      },
      h4: {
        font_family: "Montserrat",
        font_size: "17",
        color: { r: 0, g: 0, b: 0, a: 1 },
        margin_bottom: "6",
        line_height: "1.25",
      },
      p: {
        font_family: "Montserrat",
        font_size: "15",
        color: { r: 0, g: 0, b: 0, a: 1 },
        margin_bottom: "12",
        line_height: "1.5",
      },
    },
  },
  containerWidth: 1200,
  selectedFont: "Montserrat",
  bgImage: "",
  bgImageId: "",
  navigationSearch: false,
  navigationAlign: "right",
  bgImageContainer: "",
  bgImageContainerId: "",
  bgRepeat: "no-repeat",
  bgSize: "auto",
  bgContainerRepeat: "no-repeat",
  bgContainerSize: "auto",
  bgVideo: "",
  bgType: "",
  colorsGlobal: [],
  layout: [],
  preset: [],
  imagesGlobal: [],
  percentage: false,
  pixel: true,
  bgImageIndex: "",
  editTextIndex: "",
  reloadAPI: false,
  layoutList: [["home", []]],
  layoutTitle: "home",
  layoutLanguages: ["en"],
  anchorNavigation: {
    "enable": false,
    "sticky": false,
    "page": "home",
    "tabs": []
  },
  flimpTemplateID: null,
  chatbot: {
    url: "",
    display: false,
    id: "",
    buttonColor: "#1A202C",
    buttonTextColor: "#ffffff",
    buttonText: "Chat with us",
  },
};
const defaultElementsFont = {
  h1: {
    font_family: "Montserrat",
    font_size: "40",
    color: { r: 0, g: 0, b: 0, a: 1 },
    margin_bottom: "9",
    line_height: "1",
  },
  h2: {
    font_family: "Montserrat",
    font_size: "34",
    color: { r: 0, g: 0, b: 0, a: 1 },
    margin_bottom: "8",
    line_height: "1",
  },
  h3: {
    font_family: "Montserrat",
    font_size: "24",
    color: { r: 0, g: 0, b: 0, a: 1 },
    margin_bottom: "6",
    line_height: "1.1",
  },
  h4: {
    font_family: "Montserrat",
    font_size: "17",
    color: { r: 0, g: 0, b: 0, a: 1 },
    margin_bottom: "6",
    line_height: "1.25",
  },
  p: {
    font_family: "Montserrat",
    font_size: "15",
    color: { r: 0, g: 0, b: 0, a: 1 },
    margin_bottom: "12",
    line_height: "1.5",
  },
};
const reducer = (state = canvas, action) => {
  switch (action.type) {
    case actionTypes.SET_CHATBOT_CONTENT:
      return {
        ...state,
        chatbot: {
          ...state.chatbot,
          content: action.result,
        },
      };
    case actionTypes.SET_CHATBOT_URL:
      return {
        ...state,
        chatbot: {
          ...state.chatbot,
          url: action.result,
        },
      };
    case actionTypes.SET_CHATBOT_DISPLAY:
      return {
        ...state,
        chatbot: {
          ...state.chatbot,
          display: action.result,
        },
      };
    case actionTypes.GET_CHATBOT_CONTENT:
      return state;
    case actionTypes.GET_CHATBOT_URL:
      return state;
    case actionTypes.GET_CHATBOT_DISPLAY:
      return state;
    case actionTypes.SET_CHATBOT_BUTTON_COLOR:
      return {
        ...state,
        chatbot: {
          ...state.chatbot,
          buttonColor: action.result,
        },
      };
    case actionTypes.GET_CHATBOT_BUTTON_COLOR:
      return state;
    case actionTypes.SET_CHATBOT_BUTTON_TEXT_COLOR:
      return {
        ...state,
        chatbot: {
          ...state.chatbot,
          buttonTextColor: action.result,
        },
      };
    case actionTypes.GET_CHATBOT_BUTTON_TEXT_COLOR:
      return state;
    case actionTypes.SET_CHATBOT_BUTTON_TEXT:
      return {
        ...state,
        chatbot: {
          ...state.chatbot,
          buttonText: action.result,
        },
      };
    case actionTypes.GET_CHATBOT_BUTTON_TEXT:
      return state;
    case actionTypes.GLOBAL_COLORS:
      return { ...state, colorsGlobal: action.result };
    case actionTypes.HAMBURGER_COLOR:
      return { ...state, hamburgerColor: action.result };
    case actionTypes.HAMBURGER_MENU:
      return {
        ...state,
        hamburgerMenu: {
          ...state.hamburgerMenu,
          menu: action.result,
        },
      };
    case actionTypes.HAMBURGER_MENU_LABEL:
      return {
        ...state,
        hamburgerMenu: {
          ...state.hamburgerMenu,
          label: action.result,
        },
      };
    case actionTypes.ADD_BG:
      return {
        ...state,
        containerBgColor: action.result,
      };
    case actionTypes.ENABLE_WIDTH_FOR_ROW:
      return {
        ...state,
        enableWidthForRow: action.result,
      };
    case actionTypes.ADD_BG_SURROUND:
      return {
        ...state,
        surroundBg: action.result,
      };
    case actionTypes.EMPTY_PRESET:
      return {
        ...state,
        preset: action.result,
        colorsGlobal: [],
      };
    case actionTypes.PRESET:
      return {
        ...state,
        preset: action.result,
      };
    case actionTypes.ADD_FONT:
      return {
        ...state,
        selectedFont: action.result,
      };
    case actionTypes.CONTAINER_WIDTH:
      return {
        ...state,
        containerWidth: action.result,
      };
    case actionTypes.PIXEL:
      return {
        ...state,
        pixel: action.result,
      };
    case actionTypes.PERCENTAGE:
      return {
        ...state,
        percentage: action.result,
      };
    case actionTypes.BG_IMAGE:
      return {
        ...state,
        bgImage: action.result.bgImage,
        bgImageId: action.result.bgImageId,
      };
    case actionTypes.BG_IMAGE_CONTAINER:
      return {
        ...state,
        bgImageContainer: action.result.bgImageContainer,
        bgImageContainerId: action.result.bgImageContainerId,
      };
    case actionTypes.CANVAS_MARGIN_UNIT:
      return {
        ...state,

        canvasStyle: {
          ...state.canvasStyle,
          canvasMarginUnit: action.result,
        },
      };
    case actionTypes.CANVAS_MARGIN:
      return {
        ...state,

        canvasStyle: {
          ...state.canvasStyle,
          canvasMargin: action.result,
        },
      };
    case actionTypes.CANVAS_MARGIN_MOBILE:
      return {
        ...state,

        canvasStyle: {
          ...state.canvasStyle,
          canvasMarginMobile: action.result,
        },
      };
    case actionTypes.CANVAS_PADDING_UNIT:
      return {
        ...state,

        canvasStyle: {
          ...state.canvasStyle,
          canvasPaddingUnit: action.result,
        },
      };
    case actionTypes.CANVAS_PADDING:
      return {
        ...state,

        canvasStyle: {
          ...state.canvasStyle,
          canvasPadding: action.result,
        },
      };
    case actionTypes.CANVAS_PADDING_MOBILE:
      return {
        ...state,

        canvasStyle: {
          ...state.canvasStyle,
          canvasPaddingMobile: action.result,
        },
      };

    case actionTypes.CANVAS_ROWS_PADDING_UNIT:
      return {
        ...state,

        canvasStyle: {
          ...state.canvasStyle,
          canvasRowsPaddingUnit: action.result,
        },
      };
    case actionTypes.CANVAS_ROWS_PADDING:
      return {
        ...state,

        canvasStyle: {
          ...state.canvasStyle,
          canvasRowsPadding: action.result,
        },
      };
    case actionTypes.CANVAS_ROWS_PADDING_MOBILE:
      return {
        ...state,

        canvasStyle: {
          ...state.canvasStyle,
          canvasRowsPaddingMobile: action.result,
        },
      };
    case actionTypes.OVERRIDE_CANVAS_FONT:
      return {
        ...state,
        canvasStyle: {
          ...state.canvasStyle,
          overrideCanvasFont: action.result,
        },
      };
    case actionTypes.BG_REPEAT:
      return {
        ...state,
        bgRepeat: action.result,
      };
    case actionTypes.BG_SIZE:
      return {
        ...state,
        bgSize: action.result,
      };
    case actionTypes.BG_REPEAT_CONTAINER:
      return {
        ...state,
        bgContainerRepeat: action.result,
      };
    case actionTypes.BG_SIZE_CONTAINER:
      return {
        ...state,
        bgContainerSize: action.result,
      };

    case actionTypes.BG_VIDEO:
      return {
        ...state,
        bgVideo: action.result.bgVideo,
        bgVideoId: action.result.bgVideoId,
      };
    case actionTypes.BG_VIDEO_ID:
      return {
        ...state,
        bgVideoID: action.result,
      };
    case actionTypes.BG_TYPE:
      return {
        ...state,
        bgType: action.result,
      };
    case actionTypes.BG_IMAGES:
      return {
        ...state,
        imagesGlobal: action.result,
      };
    case actionTypes.NAVIGATION_STYLE:
      return {
        ...state,
        navigationStyle: action.result,
      };
    case actionTypes.NAVIGATION_SEARCH:
      return {
        ...state,
        navigationSearch: action.result,
      };
    case actionTypes.NAVIGATION_ALIGN:
      return {
        ...state,
        navigationAlign: action.result,
      };
    case actionTypes.BG_IMAGE_INDEX:
      return {
        ...state,
        bgImageIndex: action.result,
      };
    case actionTypes.REPLACE_MICROSITE:
      return {
        ...state,
        layoutList: action.result,
      };
    case actionTypes.LAYOUT:
      // Create a new outer array with updated inner arrays as needed
      const layoutListLocal = state.layoutList.map((item) => {
        // Check if this is the item to update
        if (item[0] === action.titleLayout) {
          // Return a new inner array with the updated value
          return [item[0], action.result];
        }
        // Otherwise, return the original item (or a copy if further protection is needed)
        return item;
      });

      return {
        ...state,
        layout: action.result,
        layoutTitle: action.titleLayout,
        layoutList: layoutListLocal,
      };
    case actionTypes.CANVAS:
      const styles = {
        ...state,
        layout: action.result.layout,
        layoutList: action.result.layoutList,
        layoutLanguages: action.result.layoutLanguages,
        layoutTitle: action.result.layoutTitle,
        anchorNavigation: action.result.anchorNavigation,
        containerBgColor: action.result.containerBgColor,
        surroundBg: action.result.surroundBg,
        enableWidthForRow: action.result.enableWidthForRow,
        preset: action.result.preset,
        navClass: action.result.navClass,
        hamburgerColor: action.result.hamburgerColor
          ? action.result.hamburgerColor
          : { r: 0, g: 0, b: 0, a: 1 },
        hamburgerMenu: action.result.hamburgerMenu
          ? action.result.hamburgerMenu
          : {
            menu: false,
            label: "",
          },
        containerWidth: action.result.containerWidth,
        selectedFont: action.result.selectedFont.replace(/\s/g, ''),
        bgImage: action.result.bgImage,
        bgImageId: action.result.bgImageId,
        canvasStyle: action.result.canvasStyle
          ? {
            ...canvas.canvasStyle,
            columnGap: action.result.canvasStyle.columnGap
              ? action.result.canvasStyle.columnGap
              : "",
            rowGap: action.result.canvasStyle.rowGap
              ? action.result.canvasStyle.rowGap
              : "",
            canvasPaddingUnit: action.result.canvasStyle.canvasPaddingUnit
              ? action.result.canvasStyle.canvasPaddingUnit
              : "px",
            canvasPadding: action.result.canvasStyle.canvasPadding
              ? action.result.canvasStyle.canvasPadding
              : canvas.canvasStyle.canvasPadding,
            canvasPaddingMobile: action.result.canvasStyle.canvasPaddingMobile
              ? action.result.canvasStyle.canvasPaddingMobile
              : canvas.canvasStyle.canvasPaddingMobile,
            canvasMarginUnit: action.result.canvasStyle.canvasMarginUnit
              ? action.result.canvasStyle.canvasMarginUnit
              : "px",
            canvasMargin: action.result.canvasStyle.canvasMargin
              ? action.result.canvasStyle.canvasMargin
              : [0, 0],
            canvasMarginMobile: action.result.canvasStyle.canvasMarginMobile
              ? action.result.canvasStyle.canvasMarginMobile
              : [0, 0],
            overrideCanvasFont: action.result.canvasStyle.overrideCanvasFont
              ? action.result.canvasStyle.overrideCanvasFont
              : false,
            elementsFont: action.result.canvasStyle.elementsFont
              ? action.result.canvasStyle.elementsFont
              : canvas.canvasStyle.elementsFont,
            canvasRowsPaddingUnit: action.result.canvasStyle
              .canvasRowsPaddingUnit
              ? action.result.canvasStyle.canvasRowsPaddingUnit
              : "px",
            canvasRowsPadding: action.result.canvasStyle.canvasRowsPadding
              ? action.result.canvasStyle.canvasRowsPadding
              : [0, 0, 0, 0],
            canvasRowsPaddingMobile: action.result.canvasStyle
              .canvasRowsPaddingMobile
              ? action.result.canvasStyle.canvasRowsPaddingMobile
              : [0, 0, 0, 0],
          }
          : canvas.canvasStyle,
        bgImageContainer: action.result.bgImageContainer,
        bgImageContainerId: action.result.bgImageContainerId,
        bgRepeat: action.result.bgRepeat,
        bgSize: action.result.bgSize,
        bgContainerRepeat: action.result.bgContainerRepeat,
        bgContainerSize: action.result.bgContainerSize,
        bgVideo: action.result.bgVideo,
        bgVideoId: action.result.bgVideoId,
        bgType: action.result.bgType,
        colorsGlobal: action.result.colorsGlobal,
        percentage: action.result.percentage,
        pixel: action.result.pixel,
        chatbot: action.result.chatbot || { content: "" },
      };
      if (action.result.canvasStyle) {
        const elementsFont = action.result.canvasStyle.elementsFont;
        if (elementsFont) {
          ['h1', 'h2', 'h3', 'h4', 'p'].forEach(key => {
            if (
              elementsFont[key] === null ||
              elementsFont[key] === undefined ||
              (Array.isArray(elementsFont[key]) && elementsFont[key].length === 0) ||
              (typeof elementsFont[key] === 'object' && Object.keys(elementsFont[key]).length === 0)
            ) {
              elementsFont[key] = { ...defaultElementsFont[key] };
            }
          });
          Object.keys(elementsFont).forEach(key => {
            if (elementsFont[key] && typeof elementsFont[key] === 'object' && elementsFont[key].font_family) {
              elementsFont[key].font_family = elementsFont[key].font_family.replace(/\s/g, '');
            }
          });
        }
      }
      return styles;
    case actionTypes.INFO_TITLE:
      return {
        ...state,
        title: action.result,
        // description: action.result
        // meta_title: action.result.flimp_meta_title
      };
    case actionTypes.INFO_DESC:
      return {
        ...state,
        // title: action.result.flimp_title,
        description: action.result,
        // meta_title: action.result.flimp_meta_title
      };
    case actionTypes.INFO_META_TITLE:
      return {
        ...state,
        // title: action.result.flimp_title
        // description: action.result.flimp_desc,
        meta_title: action.result,
      };
    case actionTypes.RESET:
      return {
        ...state,
        layout: [],
        title: "",
        description: "",
      };
    case actionTypes.TITLE:
      return {
        ...state,
        title: action.result,
      };
    case actionTypes.DESCRIPTION:
      return {
        ...state,
        description: action.result,
      };
    case actionTypes.NAV_CLASS:
      return {
        ...state,
        navClass: action.result,
      };
    case actionTypes.TEXT_INDEX:
      return {
        ...state,
        editTextIndex: action.result,
      };
    case actionTypes.RELOAD_API:
      return {
        ...state,
        reloadAPI: action.result,
      };
    case actionTypes.SET_LAYOUT_LIST:
      return {
        ...state,
        layoutList: action.result,
      };
    case actionTypes.SET_LAYOUT_TITLE:
      let layoutListCopy = [...state.layoutList];
      layoutListCopy.push([action.result, []]);

      return {
        ...state,
        layout: [],
        layoutList: layoutListCopy,
        layoutTitle: action.result,
      };
    case actionTypes.REORDER_LAYOUT_LIST:
      const { _layoutList, _layoutLanguages } = action.result;
      return {
        ...state,
        layoutList: _layoutList,
        layoutLanguages: _layoutLanguages,
      };
    case actionTypes.RENAME_LAYOUT_LIST:
      return {
        ...state,
        layoutList: action.result,
        // layoutTitle: action.title
      };
    case actionTypes.SET_LAYOUT_LANGUAGES:
      return {
        ...state,
        layoutLanguages: action.result,
      };
    case actionTypes.SET_ANCHOR_NAVIGATION:
      return {
        ...state,
        anchorNavigation: action.result,
      };
    case actionTypes.ENABLE_ANCHOR_NAVIGATION:
      return {
        ...state,
        anchorNavigation: {
          ...state.anchorNavigation,
          page: state.layoutTitle,
          enable: !state.anchorNavigation.enable,
        },
      };
    case actionTypes.SET_STICKY_ANCHOR_NAVIGATION:
      return {
        ...state,
        anchorNavigation: {
          ...state.anchorNavigation,
          sticky: !state.anchorNavigation.sticky,
        },
      };
    case actionTypes.SET_DEFAULT_PAGE:
      return {
        ...state,
        anchorNavigation: { ...state.anchorNavigation, page: action.payload },
      };
    case actionTypes.SET_ANCHOR_LIST:
      return {
        ...state,
        anchorNavigation: { ...state.anchorNavigation, tabs: action.payload },
      };
    case actionTypes.ADD_ANCHOR:
      return {
        ...state,
        anchorNavigation: {
          ...state.anchorNavigation,
          tabs: [...state.anchorNavigation.tabs, action.payload],
        },
      };
    case actionTypes.RENAME_ANCHOR:
      const { index, newName, newLink } = action.payload;
      const updatedTabs = [...state.anchorNavigation.tabs];
      if (updatedTabs[index])
        updatedTabs[index] = { name: newName, link: newLink };
      return {
        ...state,
        anchorNavigation: {
          ...state.anchorNavigation,
          tabs: updatedTabs,
        },
      };
    case actionTypes.DELETE_ANCHOR:
      return {
        ...state,
        anchorNavigation: {
          ...state.anchorNavigation,
          tabs: state.anchorNavigation.tabs.filter(
            (_, index) => index !== action.payload
          ),
        },
      };

    case actionTypes.FLIMP_TMP_ID:
      return {
        ...state,
        flimpTemplateID: action.result,
        // layoutTitle: action.title
      };
    case actionTypes.DELETE_LAYOUT_LIST:
      const newList = action.result.filter((item, index) => {
        return index !== action.deletedItemIndex;
      });

      const newTitle = newList[0][0];
      const newLayout = newList[0][1];

      return {
        ...state,
        layoutList: newList,
        layoutTitle: newTitle,
        layout: newLayout,
      };

    case actionTypes.OVERRIDE_ELEMENT_FONTS:
      return {
        ...state,
        canvasStyle: {
          ...state.canvasStyle,
          elementsFont: { ...action.result },
        },
      };

    case actionTypes.CANVAS_COLUMN_GAP:
      return {
        ...state,

        canvasStyle: {
          ...state.canvasStyle,
          columnGap: action.result,
        },
      };

    case actionTypes.CANVAS_ROW_GAP:
      return {
        ...state,

        canvasStyle: {
          ...state.canvasStyle,
          rowGap: action.result,
        },
      };

    case actionTypes.RESET_PAST:
      return {
        ...state,

        past: {
          ...state.past,
          length: 0,
        },
      };
  }
  return state;
};

const undoableReducer = undoable(reducer, {
  filter: excludeAction([
    actionTypes.ADD_BG,
    actionTypes.ADD_BG_SURROUND,
    actionTypes.ADD_FONT,
    actionTypes.CONTAINER_WIDTH,
    actionTypes.BG_IMAGE,
    actionTypes.BG_IMAGE_CONTAINER,
    actionTypes.GLOBAL_COLORS,
    actionTypes.PRESET,
    actionTypes.BG_IMAGES,
    actionTypes.PERCENTAGE,
    actionTypes.PIXEL,
    actionTypes.BG_IMAGE_INDEX,
    actionTypes.TEXT_INDEX,
    actionTypes.NAV_CLASS,
    actionTypes.RELOAD_API,
    actionTypes.SET_CHATBOT_CONTENT,
    actionTypes.SET_CHATBOT_URL,
    actionTypes.SET_CHATBOT_DISPLAY,
    actionTypes.SET_CHATBOT_BUTTON_COLOR,
    actionTypes.SET_CHATBOT_BUTTON_TEXT_COLOR,
    actionTypes.SET_CHATBOT_BUTTON_TEXT,
    actionTypes.GET_CHATBOT_CONTENT,
    actionTypes.GET_CHATBOT_URL,
    actionTypes.GET_CHATBOT_DISPLAY,
    actionTypes.GET_CHATBOT_BUTTON_COLOR,
    actionTypes.GET_CHATBOT_BUTTON_TEXT_COLOR,
    actionTypes.GET_CHATBOT_BUTTON_TEXT,
  ]),
  // filter: includeAction(actionTypes.LAYOUT)
});
export default undoableReducer;
